import React from "react";

class Background extends React.Component {
  onChange = (event) => {
    this.props.onChange(event.target.value);
  };

  render() {
    if (this.props.struct) {
      //      console.log(this.props.struct);
    }
    return (
      <React.Fragment>
        <label htmlFor="background-input" className="background-label">
          Background
        </label>
        <input
          id="background-input"
          className="background-input"
          value={this.props.value}
          onChange={this.onChange}
          spellCheck={false}
        ></input>
        <span style={{ gridColumn: 3 }}></span>
      </React.Fragment>
    );
  }
}

export default Background;
